/**
 * /dev/design-system — vitrine interna dos primitivos do Design System
 * Bloco D (Sprint 3). NÃO é tela de produto; serve para validar
 * visualmente Block + ListView (table ↔ cards) lado a lado com mock data,
 * sem depender de backend.
 *
 * Rota registrada em App.jsx (apenas dev/QA). Pode ser removida quando os
 * primitivos estiverem aplicados em todas as telas reais.
 */
import React, { useState } from "react";
import Block from "../../components/Block";
import ListView from "../../components/ListView";
import {
  PageContainer,
  PageTitle,
  PageTopBar,
  Section,
  SectionTitle,
} from "../../styles/shared";

const MOCK_PEDIDOS = [
  { id: 1, numero: "PV-UN1-101", cliente: "Marcenaria Vidotto Ltda", situacao: "Aprovado", tone: "success", valor: "R$ 28.420", criado: "16/05/2026", vendedor: "Camila V." },
  { id: 2, numero: "PV-UN1-102", cliente: "Habitar Construções & Cia", situacao: "Em produção", tone: "info", valor: "R$ 64.180", criado: "14/05/2026", vendedor: "Bruno P." },
  { id: 3, numero: "PV-UN1-103", cliente: "Lopes Móveis & Cia", situacao: "Aguardando NF", tone: "warning", valor: "R$ 11.920", criado: "10/05/2026", vendedor: "Camila V." },
  { id: 4, numero: "PV-UN1-104", cliente: "Escritório Boutique Advocacia", situacao: "Cancelado", tone: "danger", valor: "R$ 4.300", criado: "08/05/2026", vendedor: "Marina C." },
];

function Badge({ tone, children }) {
  // Usa a classe canônica .badge + modifier de tom (Design System Bloco D).
  return <span className={`badge badge--${tone}`}>{children}</span>;
}

const COLUMNS = [
  { key: "numero", label: "Nº", priority: "primary", width: "16%",
    render: (p) => <strong style={{ fontFamily: "var(--font-mono)", color: "var(--ink)" }}>{p.numero}</strong> },
  { key: "cliente", label: "Cliente", priority: "primary", width: "28%" },
  { key: "situacao", label: "Situação", cardSlot: "badge", width: "16%",
    render: (p) => <Badge tone={p.tone}>{p.situacao}</Badge> },
  { key: "valor", label: "Valor", priority: "primary", cardSlot: "aside", align: "right", width: "14%",
    render: (p) => <strong style={{ color: "var(--ink)" }}>{p.valor}</strong> },
  { key: "criado", label: "Criado", priority: "secondary", width: "14%" },
  { key: "vendedor", label: "Vendedor", priority: "hidden-mobile", width: "12%" },
];

export default function DevDesignSystem() {
  const [mode, setMode] = useState(undefined); // undefined = responsivo

  const segBtn = (value, label) => (
    <button
      type="button"
      className={mode === value ? "tab active" : "tab"}
      onClick={() => setMode(value)}
      style={{ border: "1px solid var(--border)" }}
    >
      {label}
    </button>
  );

  return (
    <PageContainer>
      <PageTopBar>
        <PageTitle>Design System — Primitivos (dev)</PageTitle>
        <div className="topbar__tabs" style={{ gap: 4 }}>
          {segBtn(undefined, "Responsivo")}
          {segBtn("table", "Forçar tabela")}
          {segBtn("cards", "Forçar cards")}
        </div>
      </PageTopBar>

      <Section>
        <SectionTitle>Block</SectionTitle>
        <Block
          title="Cliente"
          subtitle="Dados do pedido"
          actions={<button className="btn btn--ghost">Editar</button>}
        >
          <div style={{ color: "var(--ink-2)", fontSize: "var(--text-md)" }}>
            Marcenaria Vidotto Ltda · CNPJ 12.345.678/0001-90 ·
            contato@vidotto.com.br
          </div>
        </Block>
      </Section>

      <Section>
        <SectionTitle>
          ListView — tabela em desktop, cards em mobile (mesma data + colunas)
        </SectionTitle>
        <ListView
          data={MOCK_PEDIDOS}
          columns={COLUMNS}
          rowKey={(p) => p.id}
          forceMode={mode}
          onRowClick={(p) => window.alert(`Clicou em ${p.numero}`)}
          emptyState="Nenhum pedido encontrado."
        />
      </Section>

      <Section>
        <SectionTitle>ListView — estado vazio</SectionTitle>
        <ListView
          data={[]}
          columns={COLUMNS}
          rowKey={(p) => p.id}
          forceMode={mode}
          emptyState="Nenhum pedido encontrado — criar primeiro pedido →"
        />
      </Section>

      <Section>
        <SectionTitle>ListView — loading (skeleton)</SectionTitle>
        <ListView
          data={[]}
          columns={COLUMNS}
          rowKey={(p) => p.id}
          loading
          loadingRows={4}
        />
      </Section>
    </PageContainer>
  );
}
